import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import ShareAnalyticDetailsWorkMirrorList from './ShareAnalyticDetailsWorkMirrorList'
import ShareAnalyticDetailsWorkMirrorConstellationCard from './ShareAnalyticDetailsWorkMirrorConstellationCard'
import GlDateManager from '../../../share/GlDateManager'
import GlLegalText from '../../../share/GlLegalText'
import {
  selectAnalyticDetailsStateAnalyticDetails,
  selectAnalyticDetailsStateWorkMirrorBookDetailsCardValues,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import { analyticDetailsV2StateGetBookDetailsData } from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import WorkMirrorBookDetailsCard from '../../../analytics-details-v2/view/work-mirror/WorkMirrorBookDetailsCard'

const ShareAnalyticDetailsWorkMirrorView = () => {
  const { t } = useTranslation()
  const [openListCard, setOpenListCard] = useState<boolean>(false)

  const dispatch = useAppDispatch()

  const {
    isLoadingBookDetailsGetBookReco,
    bookDetailsBookReco,
    isLoadingGetBookDetails,
    isLoadingGetEditions,
    isLoadingGetB2BBookDetails,
    bookDetailsSelected,
    bookDetailsSelectedEditions,
    bookDetailsSelectedB2BInfo,
  } = useAppSelector(selectAnalyticDetailsStateWorkMirrorBookDetailsCardValues)

  const analyticsDetails = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetails,
  )

  const handleOpenListView = () => {
    setOpenListCard(!openListCard)
  }

  const handleCloseBookDetails = useCallback(() => {
    void dispatch(
      analyticDetailsV2StateGetBookDetailsData({ bookDetails: null }),
    )
  }, [bookDetailsSelected, bookDetailsSelectedB2BInfo])

  const handleCloseList = () => {
    setOpenListCard(false)
  }

  const [bookEanIdHovered, setBookEanIdHovered] = useState<number | null>(null)
  const handleBookHovered = useCallback(
    (eanId: number | null) => {
      setBookEanIdHovered(eanId)
    },
    [bookEanIdHovered],
  )

  return (
    <div className="flex-auto flex flex-col p-8 gap-2">
      <GlDateManager
        prefix={t('ReportReaderShipProfileDate')}
        date={analyticsDetails.modified}
      />
      <div className="flex-auto flex flex-row gap-2">
        <ShareAnalyticDetailsWorkMirrorConstellationCard
          openListCard={openListCard}
          handleOpenListView={handleOpenListView}
          handleBookHovered={handleBookHovered}
        />
        {(bookDetailsSelected && (
          <WorkMirrorBookDetailsCard
            isLoadingBookDetailsGetBookReco={isLoadingBookDetailsGetBookReco}
            bookDetailsBookReco={bookDetailsBookReco}
            isLoadingGetBookDetails={isLoadingGetBookDetails}
            isLoadingGetEditions={isLoadingGetEditions}
            isLoadingGetB2BBookDetails={isLoadingGetB2BBookDetails}
            openListCard={openListCard}
            bookDetails={bookDetailsSelected}
            bookDetailsSelectedEditions={bookDetailsSelectedEditions}
            bookDetailsSelectedB2BInfo={bookDetailsSelectedB2BInfo}
            handleCloseBookDetails={handleCloseBookDetails}
          />
        )) ||
          (openListCard && (
            <ShareAnalyticDetailsWorkMirrorList
              bookEanIdHovered={bookEanIdHovered}
              handleCloseList={handleCloseList}
            />
          )) ||
          null}
      </div>
      <GlLegalText />
    </div>
  )
}

export default ShareAnalyticDetailsWorkMirrorView
